import { useEffect, useState } from "react";

/** Align with TG LayoutV1 `md:` breakpoint (768px). */
export const CRM_MOBILE_MAX = 767;
export const CRM_TABLET_MAX = 1023;

export function useCrmBreakpoint() {
  const [width, setWidth] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 1024,
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = width <= CRM_MOBILE_MAX;
  const isTablet = width > CRM_MOBILE_MAX && width <= CRM_TABLET_MAX;

  return {
    width,
    isMobile,
    isTablet,
    isDesktop: width > CRM_TABLET_MAX,
    pagePad: isMobile ? 16 : 24,
  };
}
